var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9144 18.6892L14.9999 14.5377V15.8424L10.4604 20.4552L5.921 15.8424V14.5377L10.0065 18.6892V8.96289H10.9144V18.6892ZM4.96501 2.2767L0.879517 6.42816V5.12348L5.41896 0.510742L9.9584 5.12348V6.42816L5.8729 2.2767V12.003H4.96501V2.2767Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortNewIcon);
export default __webpack_public_path__ + "static/media/sort__new_icon.59e8d94e3334b552c7e6e9a25012a584.svg";
export { ForwardRef as ReactComponent };